import { FC, ReactNode } from 'react'

import { Typography } from '~ui'

import styles from './Card.module.scss'

const Card: FC<{ title: string; imgSrc: string; list: string[]; children?: ReactNode }> = ({
  children = null,
  imgSrc,
  title,
  list,
}) => (
  <div key={title} className={styles.card}>
    <img width={330} src={imgSrc} alt="alt" />
    <Typography.Text size="lg" color="g-green" center bold>
      {title}
    </Typography.Text>
    <ul>
      {list.map((text) => (
        <li key={text}>
          <Typography.Text color="g-white" size="md">
            {text}
          </Typography.Text>
        </li>
      ))}
    </ul>
    {children && <div className={styles.bottom}>{children}</div>}
  </div>
)

export default Card
